<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="4">
            <v-text-field
              label="Ano/Série"
              v-model="form.filters.nome"
              outlined
              dense
              hide-details
              maxlength="25"
              @keyup.enter="buscarSeries"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-select
              label="Quantidade de Bimestres"
              v-model="form.filters.quantidadeBimestres"
              outlined
              dense
              hide-details
              :items="form.lists.quantidadeBimestres"
              @keyup.enter="buscarSeries"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="4">
            <v-select
              label="Modalidade de Ensino"
              v-model="form.filters.modalidade"
              outlined
              hide-details
              dense
              :items="form.lists.modalidades"
              item-value="id"
              item-text="nome"
              @keyup.enter="buscarSeries"
            ></v-select>
          </v-col>
          <sca-select-ativo
            :cols="4"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarSeries"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarSeries()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterSerie()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        :no-data-text="table.noDataText"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw">
              {{ item.descricao }}
            </p>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarSerie(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterSerie(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarSerie(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarSerieDialog
      :edit="dialogManterSerie.edit"
      :visible="dialogManterSerie.visible"
      :content="dialogManterSerie.content"
      :modalidades="form.lists.modalidades"
      :quantidadeBimestres="form.lists.quantidadeBimestres"
      @onClose="dialogManterSerie.close()"
      @onSave="buscarSeries()"
    ></CadastrarEditarSerieDialog>
    <VisualizarSerieDialog
      v-if="dialogVisualizarSerie.visible"
      :visible="dialogVisualizarSerie.visible"
      :content="dialogVisualizarSerie.content"
      @onClose="dialogVisualizarSerie.close()"
    ></VisualizarSerieDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Serie } from '~/commons/classes/serie';
import SerieService from '~/services/serie.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarSerieDialog from "./dialogs/CadastrarEditarSerieDialog.vue";
import VisualizarSerieDialog from "./dialogs/VisualizarSerieDialog.vue";

export default {
  name: "ManterSeriesView",
  mixins: [SerieService, datatablesMixin],
  components: {
    CadastrarEditarSerieDialog,
    VisualizarSerieDialog,
  },
  data: () => ({
    dialogManterSerie: Dialog.Build(),
    dialogVisualizarSerie: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        codigo: null,
        ativo: null,
      },
      lists: {
        modalidades: [],
        quantidadeBimestres: [],
      }
    },
    table: {
      headers: [
        { text: 'Ano/Série', align: 'center', value: 'nome' },
        { text: 'Modalidade de Ensino', align: 'center', value: 'modalidade' },
        { text: 'Quantidade de Bimestres', align: 'center', value: 'quantidadeBimestres' },
        { text: 'O que é esperado do aluno', align: 'center', value: 'data-table-expand' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false  },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
      noDataText: '',
    },
  }),
  methods: {
    iniciarMensagemDeNenhumRegistroEncontrado() {
      this.table.noDataText = this.$possuiPermissao('serie.listar')
        ? ''
        : 'Não há registros a serem exibidos';
    },
    iniciarQuantidadeBimestres() {
      this.form.lists.quantidadeBimestres = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
    },
    buscarModalidades() {
      this.$buscarModalidades().then(({ data }) => (this.form.lists.modalidades = data.itens))
    },
    buscarSeries() {
      this.table.noDataText = 'Não há registros a serem exibidos';
      this.$buscarSeries({ params: this.form.filters }).then(({ data }) => (this.table.itens = data.itens));
    },
    openDialogManterSerie(serie) {
      serie
        ? this.$visualizarSeries(serie).then(
          ({ data }) => this.dialogManterSerie.open(new Serie(data.resposta), true))
        : this.dialogManterSerie.open(Serie.Build());
    },
    openDialogVisualizarSerie(serie) {
      this.$visualizarSeries(serie).then(
        ({ data }) => this.dialogVisualizarSerie.open(new Serie(data.resposta)));
    },
    inativarAtivarSerie(serie) {
      this.$swal({
        text: `Deseja ${serie.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarSerie(serie.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarSeries();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.pesquisou = false;
      this.form.filters.ativo = null;
    },
  },
  mounted() {
    this.iniciarMensagemDeNenhumRegistroEncontrado();
    this.iniciarQuantidadeBimestres();
    this.buscarModalidades();
    this.hidePageLoading();
  },
};
</script>
